<div class="migration-action-cell" (click)="$event.stopPropagation()">
  <button type="button" class="action-link primary" (click)="onOpen($event)">
    <wm-common-text [data]="{ text: 'Open' }"></wm-common-text>
  </button>
</div>
